import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'

Vue.config.productionTip = false
import Buefy from 'buefy'
import './assets/buefy.scss'
Vue.use(VueRouter)
import router from './router'
Vue.use(Buefy)
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
